import { useSearchParams } from "react-router-dom";
import signOut from "../functions/userIdentity/signOut";
import brokenimage from "./broken-task.png";
import { getTheme } from "../functions/themeService/themeService";


const ErrorPage = () => {
    const [searchParams] = useSearchParams();
    const errorCode = searchParams.get("errorCode") || "Unknown";
    const errorMessage = searchParams.get("errorMessage") || "An unexpected error occurred.";
    const theme = getTheme();
    return (
        <div className="gt-container th-gt">
            <header className="gt-header">
                <div className="gt-header__logo">
                    <svg className="gt-logo" xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref="#globaltasks-svg-logo-icon"></use>
                        <use xlinkHref={theme ? theme === 'light' ? '#globaltasks-svg-logo' : '#globaltasks-svg-logo-dark' : '#globaltasks-svg-logo'}></use>
                    </svg>
                </div>
                <button type="button" className="gw-button gw-button--secondary" onClick={() => { window.open("https://support.texthelp.com/help/globaltasks", "_blank"); }}>Support</button>
            </header>
            <div className="gt-content gt-content__error">
                <img src={ brokenimage} alt="broken task" />
                <h1>Whoops, something went wrong</h1>
                <p>Error code: {errorCode}</p>
                <p>Error message: {errorMessage}</p>
                <button type="button" className="gw-button gw-button--s3 gw-button--primary" onClick={() => { signOut(); }}>Logout</button>
            </div>
        </div>
    );
}
export default ErrorPage;